import { LESSON_ACTIVITIES } from 'global/constants';
import { Box, BoxList } from 'approot/shared/design-system/box/box.style';
import { getTextFromRichtext } from 'approot/shared/logic/get-text-from-richtext';
import { inquisitiveLogoSvg } from 'approot/activity-builder/introduction/activity-builder-intro';
import { ActivityPrintMetadata } from './activity-answers-print.constants';
import * as Styled from './activity-answers-print-intro.style';

type Props = ActivityPrintMetadata;

const ActivityAnswersPrintIntro = ({
  userName,
  userClassName,
  imageUrl,
  focusQuestion,
  phenomena,
  contentName,
  contentType,
  unitName,
  subjectName,
}: Props) => {
  return (
    <Styled.ActivityAnswersPrintIntro>
      <Box $alignItems="flex-start">
        <Styled.ActivityAnswersPrintDetails>
          <BoxList $flexDirection="column" $gap={24}>
            {userName && (
              <li>
                <Styled.ActivityAnswersPrintText>
                  Name
                </Styled.ActivityAnswersPrintText>
                <Styled.ActivityAnswersPrintValue>
                  {userName}
                </Styled.ActivityAnswersPrintValue>
              </li>
            )}
            {userClassName && (
              <li>
                <Styled.ActivityAnswersPrintText>
                  Class Name
                </Styled.ActivityAnswersPrintText>
                <Styled.ActivityAnswersPrintValue>
                  {userClassName}
                </Styled.ActivityAnswersPrintValue>
              </li>
            )}
            {focusQuestion && (
              <li>
                <Styled.ActivityAnswersPrintText>
                  Focus Question
                </Styled.ActivityAnswersPrintText>
                <Styled.ActivityAnswersPrintValue>
                  {getTextFromRichtext({
                    richtext: focusQuestion,
                    sourceFile: 'activity-answers-print-intro.tsx',
                  })}
                </Styled.ActivityAnswersPrintValue>
              </li>
            )}
            {phenomena && (
              <li>
                <Styled.ActivityAnswersPrintText>
                  Phenomena
                </Styled.ActivityAnswersPrintText>
                <Styled.ActivityAnswersPrintValue>
                  {getTextFromRichtext({
                    richtext: phenomena,
                    sourceFile: 'activity-answers-print-intro.tsx',
                  })}
                </Styled.ActivityAnswersPrintValue>
              </li>
            )}
            {contentName && (
              <li>
                <Styled.ActivityAnswersPrintText>
                  {contentType === LESSON_ACTIVITIES ? 'Lesson' : 'Assessment'}
                </Styled.ActivityAnswersPrintText>
                <Styled.ActivityAnswersPrintValue>
                  {contentName}
                </Styled.ActivityAnswersPrintValue>
              </li>
            )}
            {unitName && (
              <li>
                <Styled.ActivityAnswersPrintText>
                  Unit
                </Styled.ActivityAnswersPrintText>
                <Styled.ActivityAnswersPrintValue>
                  {unitName}
                </Styled.ActivityAnswersPrintValue>
              </li>
            )}
            {subjectName && (
              <li>
                <Styled.ActivityAnswersPrintText>
                  Subject
                </Styled.ActivityAnswersPrintText>
                <Styled.ActivityAnswersPrintValue>
                  {subjectName}
                </Styled.ActivityAnswersPrintValue>
              </li>
            )}
          </BoxList>
        </Styled.ActivityAnswersPrintDetails>
        <Styled.ActivityAnswersPrintImageDetails>
          <Styled.ActivityAnswersPrintImageWrapper>
            <Styled.ActivityAnswersPrintImage src={imageUrl} alt="" />
          </Styled.ActivityAnswersPrintImageWrapper>
        </Styled.ActivityAnswersPrintImageDetails>
      </Box>
      <Styled.ActivityAnswersPrintLogo>
        {inquisitiveLogoSvg}
      </Styled.ActivityAnswersPrintLogo>
    </Styled.ActivityAnswersPrintIntro>
  );
};

export default ActivityAnswersPrintIntro;
